module.exports = __webpack_public_path__ + "img/1821136-83-7.d5fb171d.png";